/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:13:05
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

const createGraphic = (label = [], color = []) => {
  const children = [];
  label.forEach((ele, index) => {
    const left = index * 100;

    children.push({
      type: 'rect',
      z: 100,
      left: left,
      top: 'middle',
      shape: {
        width: 15,
        height: 10
      },
      style: {
        fill: color[index],
      }
    });
    children.push({
      type: 'text',
      z: 100,
      left: left + 20,
      top: 'middle',
      style: {
        fill: '#333',
        text: `${ele}`,
        font: '14px Microsoft YaHei'
      }
    });
  })

  return {
    type: 'group',
    top: 20,
    left: 'center',
    children,
  };
}

export default ({ title, list = [], color=[] }) => {

  return {
    title: {
      // text: 'World Population'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: 150,
      right: 0,
      bottom: 40,
      containLabel: false
    },
    xAxis: {
      show: true,
      type: 'category',
      data: title,
      axisLabel: { ...xAxisLabelColor },
    },
    yAxis: {
      type: 'value',
      name: '数字品牌价值（单位：{db|DB}）',
      nameTextStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000',
        rich: {
          db: {
            fontSize: 16,
            fontStyle: 'italic'
          }
        },
      },
      axisLabel: { ...yAxisLabelColor },
    },
    graphic: createGraphic(title, color),
    series: [
      {
        type: 'bar',
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: list.map((item, index) => ({
          value: item,
          itemStyle: { color: color[index] }
        })),
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P14/chart.js